"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesSchemaValidateTableSchema = exports.doesSchemaValidateTableSchemaKey = void 0;
const doesSchemaValidateTableSchemaKey = (schema, key) => {
    if (key === undefined)
        return true;
    const keyAttributeEntry = [...schema.keyAttributeNames.values()]
        .map(attributeName => [attributeName, schema.attributes[attributeName]])
        .find(([attributeName, attribute]) => attribute.savedAs === key.name ||
        (attribute.savedAs === undefined && attributeName === key.name));
    if (keyAttributeEntry === undefined) {
        return false;
    }
    const [, keyAttribute] = keyAttributeEntry;
    return (keyAttribute !== undefined &&
        keyAttribute.key &&
        keyAttribute.type === key.type &&
        (keyAttribute.required === 'always' || keyAttribute.defaults.key !== undefined));
};
exports.doesSchemaValidateTableSchemaKey = doesSchemaValidateTableSchemaKey;
const doesSchemaValidateTableSchema = (schema, table) => {
    const { partitionKey, sortKey } = table;
    return ((0, exports.doesSchemaValidateTableSchemaKey)(schema, partitionKey) &&
        (0, exports.doesSchemaValidateTableSchemaKey)(schema, sortKey));
};
exports.doesSchemaValidateTableSchema = doesSchemaValidateTableSchema;
